import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Icon from '../../../components/Icon';
import { MAX_REPOSITORY_SIZE } from '../../../constants/api';
import bytesToSize from '../../../utils/bytesToSize';
import { IS_APP_CODEAC, WEBSITE_URL } from '../../../constants/env';
export const TooBigRepository = ({ repositorySize }) => {
    const { t } = useTranslation();
    return _jsxs("div", { className: 'alert alert-danger', children: [_jsx(Icon, { name: 'exclamation-circle', fixedWidth: true, className: 'mr-2' }), t('repositoryIsTooBig', {
                size: bytesToSize(repositorySize),
                maxSize: bytesToSize(MAX_REPOSITORY_SIZE),
            }), IS_APP_CODEAC && (_jsxs(_Fragment, { children: [' ', _jsxs(Trans, { i18nKey: 'shrinkYourRepository', children: ["To reduce your repository size, please follow the instructions in our article", _jsx("a", { href: WEBSITE_URL +
                                    '/blog/make-your-repository-lean-and-clean.html?utm_campaign=RepositoryTooBig', target: '_blank', rel: 'noreferrer', children: "Make your repository lean and clean." })] })] }))] });
};
